import ccEmailImport from './setCcEmail'

export const setCcEmail = ccEmailImport



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/mutations/index.js